module.exports = __webpack_public_path__ + "static/main_logo-51058fd357aebc93b2393af9881d937e.jpg";